<template>
  
   <transactionlist api="1722"> </transactionlist>
  
</template>
<script>
import transactionlist from "./transactionlist";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "dollerTransactionslist",
 
  components: {
    transactionlist
  },
  
  mounted() {
     this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست تراکنش های دلاری",
      },
    ]);
  },
};
</script>
<style scoped>
</style>